<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toModifyPage">修改</a>
        <a @click="goToAliConfig">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">账户名称：</div>
        <div>{{formData.wxAccountName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">微信AppId：</div>
        <div>{{formData.wxAppId || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">微信Secret：</div>
        <div>{{formData.wxSecret || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">联系人：</div>
        <div>{{formData.contact || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">联系电话：</div>
        <div>{{formData.phone || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">备注：</div>
        <div>{{formData.memo || '无'}}</div>
      </div>

    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import {api} from '../../../api/ConfigWx'
import {errorHandler} from '../../../../utils/errorHandler'

export default {
  components: {
    TextTitle,
    Breadcrumb},
  name: 'wx-current',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '配置管理',
        name: 'ali-config'
      }, {
        value: '支付宝账户配置'
      }],
      mainTitle: '查看支付宝账户',
      subheading: '',
      formData: {},
      currentCode: ''
    }
  },
  created () {
    this.currentCode = this.$route.params.id
    this.getAliAccountByCode()
  },
  methods: {
    goToAliConfig () {
      this.$router.push({
        name: 'wx-config'
      })
    },
    toModifyPage () {
      this.$router.push({
        path: `/wx_config/modify/${this.currentCode}`
      })
    },
    getAliAccountByCode () {
      this.$axios.get(`${api.getWXAccountByCode}/${this.currentCode}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data.authStatus === '0') {
              data.authText = '未授权'
            } else if (data.authStatus === '1') {
              data.authText = '已授权'
            }
            this.formData = data
          }
        })
        .catch(errorHandler('查询支付宝账户失败'))
    }
  }
}
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigWx/WxCurrent.vue